import { GenerateSignaturePacketPageLegalEntityBankAccountsAndContactsQuery } from '@/__generated__/graphql';
import { matchContactDataWithRows } from '@/components/transactions-page/generateSignaturePacket-page/templateComponents/rowComponents/contactsComponent';
import { TwoColumnWrapper } from '@/components/transactions-page/generateSignaturePacket-page/templateComponents/styles';
import { IRenderTemplateRow } from '@/components/transactions-page/generateSignaturePacket-page/templateComponents/types';
import { useResponsive } from '@/hooks/use-responsive';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { IContactWithValue } from '../types';
import { GeneralInformationItem } from './pageRowsPreview';

interface ContactsPreviewProps {
  row: IRenderTemplateRow;
  contacts: GenerateSignaturePacketPageLegalEntityBankAccountsAndContactsQuery['legalEntity']['contacts'];
  formData: any;
}

export const ContactsPreview = ({ row, contacts, formData }: ContactsPreviewProps) => {
  const { isMobile } = useResponsive();

  const [selectedContacts, setSelectedContacts] = useState<IContactWithValue[]>([]);

  useEffect(() => {
    const selectedContacts = contacts?.filter((contact) => formData?.[row.name]?.includes(contact.id));
    const updatedSelectedContacts = selectedContacts?.map((contact) => {
      const matchedContactDataWithRows = matchContactDataWithRows(row, contact);
      return { ...contact, data: matchedContactDataWithRows.flat() };
    });
    setSelectedContacts(updatedSelectedContacts ?? []);
  }, [row, contacts, formData]);

  return (
    formData?.[row.name] && (
      <ContactsWrapper isMobile={isMobile}>
        {selectedContacts.map((contact) => (
          <ContactItem key={contact.id}>
            {contact.data.map(
              (item) =>
                item.value && (
                  <TwoColumnWrapper key={item.id} isMobile={isMobile}>
                    <GeneralInformationItem>{item.label}</GeneralInformationItem>
                    <GeneralInformationItem isBold>{item.value}</GeneralInformationItem>
                  </TwoColumnWrapper>
                )
            )}
          </ContactItem>
        ))}
      </ContactsWrapper>
    )
  );
};

const ContactsWrapper = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: ${({ isMobile }) => (isMobile ? '100%' : '60%')};
`;

const ContactItem = styled.div`
  padding: 20px;
`;
